import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'error',
  templateUrl: './app-error.component.html',
  styleUrls: ['../shared/scss/app-error.component.scss']
})
export class AppErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
